import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DateTimePickerDate from './DateTimePickerDate';
import DateTimePickerTime from './DateTimePickerTime';
import { MODE_DATE, MODE_TIME, MODE_DATETIME } from './Constants.js';

function DateTimePicker(props) {
  return (
    <div className={classnames(props.widgetClasses)} style={props.widgetStyle}>
      <ul className="list-unstyled">
        {props.showDatePicker && (
          <li>
            <DateTimePickerDate
              addDay={props.addDay}
              addWeek={props.addWeek}
              addDecade={props.addDecade}
              addMonth={props.addMonth}
              addYear={props.addYear}
              daysOfWeekDisabled={props.daysOfWeekDisabled}
              format={props.format}
              maxDate={props.maxDate}
              minDate={props.minDate}
              onClose={props.onClose}
              onShow={props.onShow}
              selectedDate={props.selectedDate}
              setSelectedDate={props.setSelectedDate}
              setViewMonth={props.setViewMonth}
              setViewYear={props.setViewYear}
              showToday={props.showToday}
              subtractDecade={props.subtractDecade}
              subtractMonth={props.subtractMonth}
              subtractYear={props.subtractYear}
              viewDate={props.viewDate}
              viewMode={props.viewMode}
            />
          </li>
        )}

        {props.mode === MODE_DATETIME && (
          <li>
            <span
              className="btn picker-switch"
              onClick={props.togglePicker}
              style={{ width: '100%' }}
            >
              <span
                className={classnames(
                  'glyphicon',
                  props.showTimePicker ? 'glyphicon-calendar' : 'glyphicon-time'
                )}
              />
            </span>
          </li>
        )}

        {props.showTimePicker && (
          <li>
            <DateTimePickerTime
              addHour={props.addHour}
              addMinute={props.addMinute}
              mode={props.mode}
              selectedDate={props.selectedDate}
              setSelectedHour={props.setSelectedHour}
              setSelectedMinute={props.setSelectedMinute}
              subtractHour={props.subtractHour}
              subtractMinute={props.subtractMinute}
              togglePeriod={props.togglePeriod}
              viewDate={props.viewDate}
            />
          </li>
        )}
      </ul>
    </div>
  );
}

DateTimePicker.propTypes = {
  showDatePicker: PropTypes.bool,
  showTimePicker: PropTypes.bool,
  subtractMonth: PropTypes.func.isRequired,
  addMonth: PropTypes.func.isRequired,
  viewDate: PropTypes.object.isRequired,
  selectedDate: PropTypes.object.isRequired,
  showToday: PropTypes.bool,
  viewMode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.oneOf([MODE_DATE, MODE_DATETIME, MODE_TIME]),
  onClose: PropTypes.func,
  onShow: PropTypes.bool,
  daysOfWeekDisabled: PropTypes.array,
  setSelectedDate: PropTypes.func.isRequired,
  subtractYear: PropTypes.func.isRequired,
  addDay: PropTypes.func.isRequired,
  addYear: PropTypes.func.isRequired,
  setViewMonth: PropTypes.func.isRequired,
  setViewYear: PropTypes.func.isRequired,
  subtractHour: PropTypes.func.isRequired,
  addHour: PropTypes.func.isRequired,
  subtractMinute: PropTypes.func.isRequired,
  addMinute: PropTypes.func.isRequired,
  addDecade: PropTypes.func.isRequired,
  subtractDecade: PropTypes.func.isRequired,
  togglePeriod: PropTypes.func.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  widgetClasses: PropTypes.object,
  widgetStyle: PropTypes.object,
  togglePicker: PropTypes.func,
  setSelectedHour: PropTypes.func,
  setSelectedMinute: PropTypes.func,
};

export default DateTimePicker;
